<template>
  <a :href="link" target="_blank">
    <img :src="src" alt="Icon" role="presentation" />
  </a>
</template>

<script>
export default {
  name: 'IconComponent',
  props: [
    'src',
    'link',
  ],
};
</script>

<style scoped lang="scss">
@use '@/assets/common.scss' as *;

a {
  display: block;
}

img {
  width: 38px;
  border-radius: 4px;
  vertical-align: middle;

  @media #{$media-large-screen} {
    width: 53px;
    border-radius: 5px;
  }
}
</style>
